import React from "react"
import {useHelp, useLocal} from "../AppContext"
import {Modal} from "../Components/Modal"
import {helpBaseUrl} from "../settings"
import {MODAL__HELP} from "../Hooks/Modal"
import style from "./Help.css"


export const Help = () => {
    const local = useLocal()
    const help = useHelp()
    const lang = local.getLangShort()
    const page = help.getContextOnce() || help.getContext()
    const src = `${helpBaseUrl}${lang}/${page}`

    return <Modal type={MODAL__HELP} tile={local.__("Hilfe")} userStyle={{width: "1000px",height: "calc(100vh - 180px)"}}>
        <div className={style.container}>
            <iframe src={src}/>
        </div>
    </Modal>
}